import React from "react";
import TableCell from "@mui/material/TableCell";

const TableHeaderCellComponent = (props) => {
  const columns = props.columns;

  return columns.map((column) => (
    <TableCell
      key={column.id}
      align={column.align}
      style={{
        minWidth: column.minWidth,
        fontWeight: "bold",
        fontSize: '1rem',
        backgroundColor: "#8ae3ff",
        color: "#00358a"
      }}
    >
      {column.label}
    </TableCell>
  ));
};

export default TableHeaderCellComponent;
